var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTestSuccess = function SvgTestSuccess(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "green",
    fillOpacity: 0.75,
    fillRule: "evenodd",
    d: "M3.423 8.244a.833.833 0 1 0-1.179 1.179l3.333 3.333a.833.833 0 0 0 1.179 0l8.333-8.333a.833.833 0 0 0-1.178-1.179l-7.744 7.744z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTestSuccess);
export { ForwardRef as ReactComponent };